import {useRef} from 'react';
const useDebounce = (cb, delay) => {
  const timeOutId = useRef(null);
  return function (...args) {
    if (timeOutId.current) {
      clearTimeout(timeOutId.current);
    }
    timeOutId.current = setTimeout(() => cb(...args), delay);
  };
};

export default useDebounce;
